import { HStack, VStack } from "@gluestack-ui/themed";
import { StoreInfoSectionProps } from "./types";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import { GeneralInfo } from "../../infos/GeneralInfo";

export const StoreInfoSection = ({
  title,
  icon,
  name,
  cnpj,
  phone,
  address,
  nsuTerminal,
  nsuProcessor,
  date,
  time
}: StoreInfoSectionProps) => {
  return (
    <VStack gap={16} py="$4">
      <HStack alignItems="center" gap={8}>
        <Icon name={icon} size={18} />
        <Text fontWeight={600}>{title}</Text>
      </HStack>

      <GeneralInfo name="Nome" value={name} />
      {cnpj && <GeneralInfo name="CNPJ" value={cnpj} />}
      {phone && <GeneralInfo name="Telefone" value={phone} />}
      {address && <GeneralInfo name="Endereço" value={address} />}
      {nsuTerminal && (
        <GeneralInfo name="NSU Terminal" value={nsuTerminal?.toString()} />
      )}
      {nsuProcessor && (
        <GeneralInfo name="NSU Processadora" value={nsuProcessor?.toString()} />
      )}
      {date && <GeneralInfo name="Data" value={date} />}
      {time && <GeneralInfo name="Hora" value={time} />}
    </VStack>
  );
};
